export function isApp(a) {
    var _a;
    return ((_a = a) === null || _a === void 0 ? void 0 : _a.token) !== undefined;
}
export function isContentItem(f) {
    var _a;
    return ((_a = f) === null || _a === void 0 ? void 0 : _a.uuid) !== undefined;
}
export function isContentVersion(f) {
    var _a;
    return ((_a = f) === null || _a === void 0 ? void 0 : _a.url) !== undefined;
}
//# sourceMappingURL=utils.js.map